import { cn } from "@/lib/utils";
import { SadieSimulatorMatchedOpportunityFit } from "@/types";

const fitToLabel: Record<SadieSimulatorMatchedOpportunityFit["fit"], string> = {
  FULL: "full match",
  PARTIAL: "partial",
  NO_SIGNAL: "no signal",
};

const fitToClass: Record<SadieSimulatorMatchedOpportunityFit["fit"], string> = {
  FULL: "bg-emerald-50 text-emerald-700",
  PARTIAL: "bg-amber-50 text-amber-700",
  NO_SIGNAL: "bg-slate-100 text-slate-600",
};

export const SadieSimulatorFitTag = ({
  fit,
}: {
  fit: SadieSimulatorMatchedOpportunityFit["fit"];
}) => (
  <span
    className={cn(
      "whitespace-nowrap rounded-md px-1.5 py-0.5 text-[11px] font-medium",
      fitToClass[fit],
    )}
  >
    {fitToLabel[fit]}
  </span>
);
